import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import AboutModal from '../../AboutModal';

export default function About({
  show,
  onHide,
}: {
  show: boolean,
  onHide: () => void,
}) {
  return (
    <AboutModal show={show} onHide={onHide}>
      <Row className="align-items-stretch">
        <Col md={6}>
          <Card className="h-100 water-balance-culture-instruction-card">
            <Card.Header className="shadow-sm">
              SOBRE
            </Card.Header>
            <Card.Body>
              <p>
                Esta funcionalidade apresenta o
                {' '}
                <b>Índice de Cultura</b>
                , um indicador que mostra o quão favoráveis estão as condições para o
                desenvolvimento de uma cultura agrícola em um determinado período. O índice é
                calculado com base na temperatura e na disponibilidade de água, levando em
                conta cada fase do ciclo do cultivo. As informações são geradas a partir de
                previsões meteorológicas e modelos agronômicos. Siga o passo a passo para acessar
                os dados corretamente.
              </p>
              <p>
                <b>Observação:</b>
                {' '}
                É possível consultar detalhadamente as informações de cada ponto cadastrado
                clicando no local de interesse no mapa.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100 water-balance-culture-instruction-card">
            <Card.Header className="shadow-sm">
              INSTRUÇÕES PARA CONSULTA
            </Card.Header>
            <Card.Body>
              <ol>
                <li>
                  Na página índice por área ou por local, selecione no menu suspenso a cultura
                  desejada.
                </li>
                <li>Escolha a data da rodada da previsão.</li>
                <li>
                  Como os modelos meteorológicos fazem novos cálculos todos os dias (as chamadas
                  rodadas), é preciso decidir qual versão mais recente da previsão usar.
                </li>
                <li>Selecione o intervalo de tempo para qual deseja visualizar o índice.</li>
                <li>
                  Informe em qual estágio fenológico a cultura deve estar durante o período
                  desejado.
                </li>
                <li>
                  Para comparar com outro período ou estágio fenológico, utilize o botão no canto
                  superior direito para adicionar um novo mapa e siga os mesmos passos descritos
                  acima.
                </li>
              </ol>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </AboutModal>
  );
}
